import React from 'react';
import { Dropdown } from 'antd';

/**
 * SbDropdown - Standardized dropdown wrapper for SkillsBridge
 * 
 * Wraps Ant Design's Dropdown component with consistent styling.
 * 
 * Usage:
 *   import { SbDropdown } from 'uiCore';
 *   
 *   const menuItems = [
 *     { key: '1', label: 'Option 1' },
 *     { key: '2', label: 'Option 2' },
 *   ];
 *   
 *   <SbDropdown menu={{ items: menuItems }} trigger={['click']}>
 *     <button>Click me</button>
 *   </SbDropdown>
 */

const SbDropdown = ({ children, ...rest }) => {
  return (
    <Dropdown {...rest}>
      {children}
    </Dropdown>
  );
};

export default SbDropdown;
